import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import MoreMenu from "src/img/SettingsMoreMenu.svg";
import axios from "axios";
import { API_URL } from "src/scenes/App";
import { DataTableActionButton, Toast } from "src/components";

function MoreMenuContainerBilling({ invoice, token, indexOfShownMenu, setIndexOfShownMenu, thisIndex }) {
    const [isDownloading, setIsDownloading] = useState(false);
    const [anchorElement, setAnchorElement] = useState(null);
    const isActive = indexOfShownMenu === thisIndex;

    const handleClick = (event) => {
        if (thisIndex === indexOfShownMenu) {
            setIndexOfShownMenu(null);
            setAnchorElement(null);
            return false;
        }

        setAnchorElement(event.currentTarget);
        setIndexOfShownMenu(thisIndex);
    };

    const handleClose = () => {
        setAnchorElement(null);
        setIndexOfShownMenu(null);
    };

    const handleDownloadInvoice = () => {
        download();
    };

    const handleContactSupport = () => {
        window.open("https://www.memotivationapp.com/contact", "_blank");
    };
    
    const download = async () => {
        if (isDownloading)
            return false;
        
        setIsDownloading(true);
        
        try {
            // Fetch PDF object from API
            let response = await axios.get(`${API_URL}/company/invoice/${invoice.uuid}/pdf`, {
                headers: {
                    Authorization: "Bearer " + token
                },
                responseType: "blob"
            });

            // Open the document in a new tab
            const type = response.headers["Content-Type"];
            const fileName = `Me Business App Tax Invoice - ${invoice.invoiceNo}.pdf`;
            const blob = new Blob([response.data], { type: type, encoding: "UTF-8" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        } catch {
            Toast.error("Unable to download invoice");
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <>
            <DataTableActionButton
                type="button"
                width="2.25rem"
                minWidth="2.25rem"
                padding="0"
                backgroundColor="transparent"
                border="none"
                aria-label="More invoice actions"
                aria-controls={isActive ? `billing-history-menu-${thisIndex}` : undefined}
                aria-expanded={isActive ? "true" : undefined}
                aria-haspopup="menu"
                onClick={handleClick}
            >
                <img src={MoreMenu} alt="" />
            </DataTableActionButton>
            <Menu
                id={`billing-history-menu-${thisIndex}`}
                anchorEl={anchorElement}
                open={isActive && Boolean(anchorElement)}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    style: {
                        minWidth: "13.75rem",
                        border: "1px solid #E9EBEF",
                        borderRadius: "8px",
                        boxShadow: "0px 5px 12px #00000026"
                    }
                }}
            >
                <MenuItem onClick={handleDownloadInvoice} disabled={isDownloading}>
                    {isDownloading ? "Downloading..." : "Download Invoice"}
                </MenuItem>
                <MenuItem onClick={handleContactSupport}>Contact Support</MenuItem>
            </Menu>
        </>
    );
}

export default MoreMenuContainerBilling;
